import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-view',
  templateUrl: './permission-view.component.html',
  styleUrls: ['./permission-view.component.css']
})
export class PermissionViewComponent {

}
